import React, { Fragment, useEffect, useState } from "react";
import Resource from "../Dcp Tutoring/Resource";
import SessionHistory from "../Dcp Tutoring/SessionHistory";
import Tasks from "../Dcp Tutoring/Tasks";
import Events from "./Events";
import { Grid } from "@mui/material";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import { getAllAssignSubject } from "../../api/subjectApi";
import { ServiceOffer, SkillPath } from "../../common/const";
import { setLoading } from "../../features/authSlice";
import { useDispatch } from "react-redux";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import SubjectOverview from "../Dcp Tutoring/SubjectOverview";
import { getScoreStats } from "../../api/scoreApi";
import ProgressBar from "../Dcp Tutoring/ProgressBar";

const SkillCoaching = ({
    currentService,
    studentId
}) => {
    const dispatch = useDispatch();
    const [assignSkill, setAssignSkill] = useState([]);
    const [subService, setSubService] = useState(null);
    const [progressData, setProgressData] = useState([]);

    const getAssignedSubject = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAllAssignSubject(ServiceOffer.skillCoach, studentId);
            setSubService(response?.data?.[0]?.student_subject_id);
            setAssignSkill(response?.data);
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    useEffect(() => {
        if (studentId) {
            getAssignedSubject();
        }
    }, [studentId]);

    const getStats = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getScoreStats(ServiceOffer.skillCoach, studentId, subService);
            dispatch(setLoading({
                loading: false
            }));
            setProgressData(response.data);
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    };

    useEffect(() => {
        getStats();
    }, [subService]);

    return (
        <Fragment>
            <Grid container spacing={2}>
                {assignSkill.length > 0 && assignSkill.map((a) => (
                    <Grid item key={a.student_subject_id} style={{ flexShrink: 0 }}>
                        <CommonButton
                            label={a?.subject?.name}
                            width="150px"
                            fontWeight={600}
                            border={subService !== a.student_subject_id ? `1px solid #0000001A` : 'none'}
                            color={subService === a.student_subject_id ? theme.palette.secondary.main : 'gray'}
                            background={subService === a.student_subject_id ? theme.palette.primary.main : '#FAFAFA'}
                            handleClick={() => setSubService(a.student_subject_id)}
                            marginBottom="0px"
                            height="35px"
                        />
                    </Grid>
                ))}
                <Grid item sm={12}>
                    <ProgressBar progressData={progressData} fromMentor />
                </Grid>
                <Grid item md={6}>
                    <Events
                        subService={subService}
                        currentService={currentService}
                        studentId={studentId}
                    />
                </Grid>
                <Grid item md={6}>
                    <Tasks
                        label="Active Coding Tasks"
                        fromMentor
                        options={assignSkill.map((a) => ({
                            label: a.subject?.name,
                            value: a.student_subject_id
                        }))}
                        isSkill
                        subService={subService}
                        currentService={currentService}
                        studentId={studentId}
                    />
                </Grid>
                <Grid item md={6} sm={12}>
                    <SubjectOverview currentService={currentService} fromMentor subService={subService} pathname={SkillPath} label={'Skill Tracking & Progress'} studentId={studentId} />
                </Grid>
                <Grid item md={6}>
                    <Resource
                        fromMentor
                        subService={subService}
                        currentService={currentService}
                        studentId={studentId}
                    />
                </Grid>
                <Grid item md={12}>
                    <SessionHistory
                        fromMentor
                        subService={subService}
                        currentService={currentService}
                        studentId={studentId}
                    />
                </Grid>
            </Grid>
        </Fragment>
    )
}

export default SkillCoaching;